exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".hidden{display:none}", "", {"version":3,"sources":["/opt/snt/front-end-turnos/src/app/layout/main/main.component.scss"],"names":[],"mappings":"AAAA,QACC,YAAa,CACb","file":"main.component.scss","sourcesContent":[".hidden {\r\n\tdisplay: none;\r\n}"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/snt/front-end-turnos/src/app/layout/main/main.component.scss
// module id = mIm/
// module chunks = 2